import {FunctionComponent, PropsWithChildren} from "react";
import {Navigate} from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import {UserRole} from "../../constants/UserRole";


const LoginRequired: FunctionComponent<PropsWithChildren> = ({children}) => {
    const {role, hasLoaded} = useAuth();

    if (!hasLoaded) {
        return <></>;
    }

    if (role !== UserRole.ADMIN) {
        return <Navigate to={'/login'} replace/>;
    }

    return <>{children}</>;
}

export default LoginRequired;